import { IS_TUPSDK } from 'app/utils/constants';
import BackNextButtons from 'components/BackNextButtons';
import AccountCapability, { AccountCapabilityFormutil } from 'components/forms/AccountCapability';
import AssetsInfo from 'components/forms/AssetsInfo';
import Checkbox from 'components/forms/Checkbox';
import EnhanceProgram, { EnhanceProgramFormutil, openAgreementModal } from 'components/forms/EnhanceProgram';
import InvestInfo from 'components/forms/InvestInfo';
import OptAgreeCheckbox from 'components/forms/InvestInfo/OptAgreeCheckbox';
import InvestTarget from 'components/forms/InvestTarget';
import TradeType, { TradeTypeFormutil } from 'components/forms/TradeType';
import Toast from 'components/Toast';
import values from 'stores/values';
import { AccountCapabilitiesEnum, CategoryEnum } from 'types/customer';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import { CategoryFormutil } from '../../type';

export type InvestFormutil = AccountCapabilityFormutil & TradeTypeFormutil & EnhanceProgramFormutil;

interface InvestProps extends ProgressFormProps<InvestFormutil> {
    isSSN: boolean;
}

const Invest: React.FC<InvestProps> = ({ isSSN, onSubmit, $formutil }) => {
    const { category } = values.getParams<CategoryFormutil>();
    const age = values.getAge();
    const { $batchState, $setValues, $getFirstError, $invalid } = $formutil;
    const { account_capabilities, opt_perm, enhance_perm, temporary_confirm_fpsl_agreement } = $formutil.$params;
    // tradeType === '1'表示用户选择了期权交易项
    const isOption = opt_perm === '1'; // 是否有其他配置项
    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();

        reportEventList('invest');

        if ($invalid) {
            $batchState({
                $touched: true,
                $dirty: true
            });

            Toast.show($getFirstError());
        } else {
            const nextPath = category === CategoryEnum.IRA ? '../beneficiary' : isSSN ? '../revenue' : '../w8';

            if (enhance_perm === '1' && !temporary_confirm_fpsl_agreement) {
                openAgreementModal({
                    exposureEventParams: {
                        model: '开户-投资信息',
                        name: '投资信息-FPSL-弹框曝光'
                    },
                    enrollEventParams: {
                        model: '开户-投资信息',
                        name: '投资信息-FPSL-弹框点击Enroll'
                    },
                    cancelEventParams: {
                        model: '开户-投资信息',
                        name: '投资信息-FPSL-弹框点击Cancel'
                    }
                }).then(async result => {
                    if (result) {
                        await $setValues({
                            temporary_confirm_fpsl_agreement: result
                        });

                        onSubmit(nextPath);
                    }
                });
            } else {
                onSubmit(nextPath);
            }
        }
    };

    return (
        <form className="open-trade-channel-root" noValidate onSubmit={handleSubmit}>
            <h3 className="open-title mt-0">{__('INVEST INFORMATION')}</h3>
            <AccountCapability category={category} />
            {account_capabilities === AccountCapabilitiesEnum.MARGIN && (
                <Checkbox
                    name="temporary_margin_check"
                    $defaultValue={true}
                    checker={value => !!value || __('请您阅读并同意上述协议')}
                    label={
                        <>
                            * {__('I have read the ')}
                            <a href="https://www.tradeup.com/agreement/178" target="_blank" data-inapp-blank>
                                {__('Margin Disclosure Statement')}
                            </a>
                            {__('and understand the risks')}
                        </>
                    }
                />
            )}
            {/** EWB TUP 不支持期权，不支持国债 */}
            <TradeType age={age} hideOption={IS_TUPSDK} hideTreasury={IS_TUPSDK} />
            <AssetsInfo />
            <InvestTarget />
            {isOption && (
                <>
                    <h4 className="mt-4 mb-3">{__('Option Investment Experience')}</h4>
                    <InvestInfo name="opt" age={age} isOption minTradeYears={2} isMarsco />
                    <OptAgreeCheckbox />
                </>
            )}
            <EnhanceProgram />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    step: 3,
    id: 'invest',
    ensure: ['baseinfo', 'baseinfo2', 'job'],
    basePath: 'open',
    eventParams: {
        exposureEventParams: {
            model: '开户-投资信息',
            name: '投资信息-页面曝光'
        },
        submitEventParams: {
            model: '开户-投资信息',
            name: '投资信息-点击下一步'
        }
    }
})(Invest);
